export default "__VITE_PUBLIC_ASSET__5ca0ee55__"